import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';

export interface OnboardingStatus {
  firmaNastavena: boolean;
  maZakazku: boolean;
  maVyrobu: boolean;
  maTym: boolean;
  maNabidku: boolean;
  maRecept: boolean;
  hasSample: boolean;
}

export function useOnboardingStatus() {
  return useQuery({ queryKey: ['onboarding'], queryFn: () => api.get<OnboardingStatus>('/api/onboarding/status') });
}

export function useSeedSample() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ created: boolean; projectId: string }>('/api/onboarding/sample-data', {}),
    onSuccess: () => {
      for (const k of ['onboarding', 'dashboard', 'projects', 'gantt', 'board', 'knowledge', 'link-index']) {
        qc.invalidateQueries({ queryKey: [k] });
      }
    },
  });
}
